import Model from './Model';

type Props = {
    readonly id: number;
    readonly name: string;
    readonly logo_url: string;
    readonly payment_method_id;
    readonly order: number;
};

export default class PaymentMethodChannel extends Model {
    public readonly id: number;
    public readonly paymentMethodId: number;
    public readonly name: string;
    public readonly logoUrl: string;
    public readonly order: number;

    constructor({ id, name, logo_url, order, payment_method_id }: Props) {
        super();
        this.name = name;
        this.id = id;
        this.paymentMethodId = payment_method_id;
        this.logoUrl = logo_url;
        this.order = order;
    }
}
